import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'app/rootReducer'
import GoBackHeader from 'components/organisms/GoBackHeader'
import Button from 'react-bootstrap/button'
import SimpleCard from 'components/atoms/SimpleCard'
import DeactivateCaseModal from '../DeactivateCaseModal'
import { incrementCaseCount } from 'reducers/authentication/authenticationSlice'
import {
  MutationCaseResponse,
  DeactivateCaseVariables,
  DEACTIVATE_CASE
} from 'share/mutations/cases'
import { useMutation } from '@apollo/client'
import './styles.scss'

const CaseInformationAndPreferences = (): JSX.Element => {
  const dispatch = useDispatch()
  const [showDeactivation, setShowDeactivation] = useState(false)
  const activeCase = useSelector((state: RootState) => state.activeCase)
  const [deactivateCase] =
    useMutation<MutationCaseResponse, DeactivateCaseVariables>(DEACTIVATE_CASE)

  const handleCloseDeactivation = () => {
    setShowDeactivation(false)
  }

  const handleDeactivation = async (deactivationReason: string) => {
    const responseMutation = await deactivateCase({
      variables: { id: activeCase.matter?.id ?? 0, reason: deactivationReason }
    })

    setShowDeactivation(false)
    dispatch(incrementCaseCount)
    if (!responseMutation) {
      console.log('Error trying to deactivate case ' + activeCase.matter?.id)
    }
  }

  return (
    <React.Fragment>
      <GoBackHeader text='Case Information' />
      <div className='ui-case-information-page' data-testid='caseinfo-page'>
        <div className='page-container mt-4 mt-lg-5'>
          <div className='container px-4'>
            <h4 className='mb-3'>
              <strong data-testid='caseinfo-header'>Case Information</strong>
            </h4>
            <SimpleCard
              title='Case Type'
              description={activeCase.matter?.caseType}
              datatestid='caseinfo-casetype'
            />
            <SimpleCard
              title='Law Firm'
              description={activeCase.matter?.firm.name}
              datatestid='caseinfo-lawfirm'
            />
            <SimpleCard
              title='Status'
              description={activeCase.matter?.status}
              datatestid='caseinfo-status'
            />

            <hr />
            <div className='ml-n3'>
              <Button
                variant='link'
                onClick={() => setShowDeactivation(true)}
                data-testid='caseinfo-deactivate-case-button'
              >
                Deactivate Case
              </Button>
            </div>
          </div>
        </div>
        <DeactivateCaseModal
          show={showDeactivation}
          onHide={handleCloseDeactivation}
          onDeactivate={handleDeactivation}
        />
      </div>
    </React.Fragment>
  )
}

export default CaseInformationAndPreferences
